import { IShipment } from '@shared/core/interfaces/shipments/shipment.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { PrivateUrlConstantsService } from '@pw-utils/services/private-url-constants/private-url-constants.service';
import { UrlConstantsService } from '@pw-utils/services/url-constants/url-constants.service';
import { IPrivateIncident, IPublicIncident } from '@shared/core/interfaces/incident.interface';
import { IListResponse } from '@shared/core/interfaces/response.interface';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IncidentService {
  constructor(
    private http: HttpClient,
    private _urls: UrlConstantsService,
    private _privateUrls: PrivateUrlConstantsService
  ) {}

  public getPrivateIncidents(params: Params = {}): Observable<IListResponse<IPrivateIncident>> {
    return this.http.get<any>(this._privateUrls.PRIVATE_INCIDENTS, { params });
  }

  public getPublicIncidents(params: Params = {}): Observable<IListResponse<IPublicIncident>> {
    return this.http.get<IListResponse<IPublicIncident>>(this._urls.PUBLIC_INCIDENTS, { params });
  }

  public getPublicIncident(id: number): Observable<IPublicIncident> {
    return this.http.get<IPublicIncident>(this._urls.PUBLIC_INCIDENT_BY_ID(id));
  }

  public getPublicIncidentShipmentDetails(id: number): Observable<Partial<IShipment>> {
    return this.http.get<Partial<IShipment>>(this._urls.PUBLIC_INCIDENT_SHIPMENT(id));
  }

  public resolveIncident(id: number, body: any): Observable<void> {
    return this.http.post<void>(this._urls.RESOLVE_PUBLIC_INCIDENT(id), body);
  }
}
